export const daysToMilliseconds = (days: number): number => {
  const millisecondsInADay = 24 * 60 * 60 * 1000
  return days * millisecondsInADay
}
